<script>
import { avatarUrlForStyle, dimensionsForStyle } from '~/utils/avatar';

// Warning: This is a non-reactive component intended for usage in report tables
// If you need the avatar to change when userId or avatarStyle change, then
// use HubApp instead
export default {
  name: 'ReportTableAvatarPlain',
  functional: true,
  props: {
    userId: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      default: undefined,
      required: false, // this or :userId
    },
    avatarStyle: {
      type: String,
      default: 'speck',
    },
  },
  render(createElement, context) {
    const avatarStyle = context.props.avatarStyle;
    const dimensions = dimensionsForStyle(avatarStyle);
    let avatarUrl = context.props.url;

    if (avatarUrl === undefined) {
      const userId = context.props.userId;
      const avatarData = context.parent.$store.getters.allAvatars.get(userId);

      avatarUrl = avatarUrlForStyle(avatarData, avatarStyle);
    } else {
      avatarUrl ??= avatarUrlForStyle(null, avatarStyle);
    }
    const attrs = {
      class: `avatar avatar-${avatarStyle}`,
      src: avatarUrl,
      height: dimensions,
      width: dimensions,
    };

    return createElement('img', {
      attrs,
    });
  },
};
</script>
